import React, { useState } from 'react';
import { Button } from 'antd';
import { LoginModal } from '@login/pages/LoginModal.tsx';

import '@login/styles/login.scss';

interface LoginButtonProps {
  /** Clase(s) extra para el botón */
  extraClass?: string;
  /** Icono: puede ser un nodo React o un string con SVG/HTML */
  intoIcon?: React.ReactNode | string;
}

const LoginButton: React.FC<LoginButtonProps> = ({ extraClass = '', intoIcon }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  return (
    <>
      <Button
        type="primary"
        shape="default"
        id="logInButton"
        size="middle"
        className={`login-trigger-btn ${extraClass}`}
        icon={typeof intoIcon === 'string' ? <span aria-hidden dangerouslySetInnerHTML={{ __html: intoIcon }} /> : intoIcon}
        onClick={openModal}
        style={{ display: 'flex', alignItems: 'center', gap: 8, fontWeight: 500 }}
      >
        Ingresar
      </Button>

      <LoginModal open={isModalOpen} onClose={closeModal} />
    </>
  );
};

export default LoginButton;
